<template>
  <div id="dashboard-view" class="app-layout" ref="dashboardWrapper">
    <Loader v-if="loading" />
    <MobileSidebar />
    <Sidebar />
    <main class="main-content">
      <Header />
      <div class="page-content">
        <router-view v-slot="{ Component }">
          <transition name="fade-transform" mode="out-in">
            <component
              :is="Component"
              class="content-wrapper"
            />
          </transition>
        </router-view>
      </div>
    </main>
  </div>
</template>

<script>
import Header from "@/layout/navigation/Header";
import Sidebar from "@/layout/navigation/Sidebar";
import MobileSidebar from "@/layout/navigation/MobileSidebar";
import Loader from "@/components/notification/Loader";
import { mapGetters } from "vuex";

export default {
  name: "DashboardView",

  components: {
    Sidebar,
    MobileSidebar,
    Header,
    Loader,
  },
  computed: {
    ...mapGetters(["loading"]),
  },
};
</script>

<style lang="scss" scoped>
.app-layout {
  display: flex;
  min-height: 100vh;
  background: #f8fafc;
}

.main-content {
  flex: 1;
  min-height: 100vh;
  width: 100%;

  @media screen and (min-width: 1280px) {
    margin-left: 260px;
    width: calc(100% - 260px);
  }
}

.page-content {
  padding-top: 80px;
  min-height: 100vh;
  background: #f8fafc;
}

.content-wrapper {
  padding: 24px 32px;
  padding-bottom: 48px;

  @media (max-width: 1024px) {
    padding: 16px;
  }

  @media (min-width: 1500px) {
    max-width: 1400px;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
